import util from '@/lib/index';

// 获取商店列表
export const getStoreList = () => util.get('server/v2/mayday/store');

// 获取用户签到天数
export const getUserInfo = (param) => util.get('server/v2/mayday/get_sign_days', param);

// 签到
export const Sign = (param) => util.get('server/v2/mayday/sign', param);

// 兑换
export const Exchange = (param) => util.get('server/v2/mayday/exchange', param);

export const getHeadAnchor = () => util.get('server/v2/yuntu/get_head_anchor');
